/* HADARA BOUTIQUE — new design behaviour (ported from approved prototype, wired to Shopify) */
(function(){
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(id){ return document.getElementById(id); }

  /* ---- Announcement rotator ---- */
  var msgs = document.querySelectorAll('.hd .announce-msg');
  if (msgs.length > 1 && !reduceMotion) {
    var mi = 0;
    setInterval(function(){
      msgs[mi].classList.remove('on');
      mi = (mi + 1) % msgs.length;
      msgs[mi].classList.add('on');
    }, 4500);
  }

  /* ---- Header shadow ---- */
  var header = $('hdSiteHeader');
  if (header) {
    window.addEventListener('scroll', function(){
      header.classList.toggle('scrolled', window.scrollY > 8);
    }, {passive:true});
  }

  /* ---- Drawers ---- */
  var overlay = $('hdOverlay');
  var mobileDrawer = $('hdMobileDrawer');
  var cartDrawer = $('hdCartDrawer');
  var burgerBtn = $('hdBurgerBtn');
  var cartBtn = $('hdCartBtn');

  function openDrawer(el, trigger){
    if (!el || !overlay) return;
    el.classList.add('on'); el.setAttribute('aria-hidden','false');
    overlay.hidden = false; requestAnimationFrame(function(){ overlay.classList.add('on'); });
    if (trigger) trigger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input'); if (f) f.focus();
  }
  function closeDrawers(){
    if (!overlay) return;
    [mobileDrawer, cartDrawer].forEach(function(el){ if(el){ el.classList.remove('on'); el.setAttribute('aria-hidden','true'); } });
    overlay.classList.remove('on');
    setTimeout(function(){ overlay.hidden = true; }, 300);
    if (burgerBtn) burgerBtn.setAttribute('aria-expanded','false');
    if (cartBtn) cartBtn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  if (burgerBtn) burgerBtn.addEventListener('click', function(){ openDrawer(mobileDrawer, burgerBtn); });
  if (cartBtn) cartBtn.addEventListener('click', function(){ renderCart(); openDrawer(cartDrawer, cartBtn); });
  var drawerClose = $('hdDrawerClose'); if (drawerClose) drawerClose.addEventListener('click', closeDrawers);
  var cartClose = $('hdCartClose'); if (cartClose) cartClose.addEventListener('click', closeDrawers);
  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeDrawers(); closeSearch(); } });

  /* ---- Search ---- */
  var searchBtn = $('hdSearchBtn');
  var searchBar = $('hdSearchBar');
  function closeSearch(){ if(searchBar){ searchBar.classList.remove('on'); } if(searchBtn){ searchBtn.setAttribute('aria-expanded','false'); } }
  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', function(){
      var on = searchBar.classList.toggle('on');
      searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var si = $('hdSearchInput'); if (si) si.focus(); }
    });
  }

  /* ---- Cart (live Shopify cart via AJAX API) ---- */
  var FREE_SHIP = 250;
  if (cartDrawer && cartDrawer.dataset.freeShipping) FREE_SHIP = parseFloat(cartDrawer.dataset.freeShipping) || 250;
  var cartState = null;

  function money(n){ return '$' + n.toFixed(2); }

  function fetchCart(){
    return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c){ cartState = c; paintCart(); return c; });
  }
  function paintCart(){
    var box = $('hdCartItems');
    if (!box || !cartState) return;
    var count = cartState.item_count;
    var subtotal = cartState.items_subtotal_price / 100;
    var badge = $('hdCartCount');
    if (badge){ badge.hidden = count === 0; badge.textContent = count; }
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Shopping bag, ' + count + ' items');
    var st = $('hdCartSubtotal'); if (st) st.textContent = money(subtotal);
    var remaining = FREE_SHIP - subtotal;
    var shipMsg = $('hdShipMsg');
    if (shipMsg) shipMsg.textContent = remaining > 0
      ? 'Spend ' + money(remaining) + ' more for free Australian shipping'
      : 'You have unlocked free Australian shipping';
    var fill = $('hdShipFill'); if (fill) fill.style.width = Math.min(100, subtotal / FREE_SHIP * 100) + '%';
    if (!cartState.items.length) { box.innerHTML = '<p class="cart-empty">' + (box.dataset.emptyText || 'Your bag is empty. Beautiful things await.') + '</p>'; return; }
    box.innerHTML = cartState.items.map(function(i){
      var img = i.image ? i.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
      var sizeLine = (i.variant_title && i.variant_title !== 'Default Title') ? '<p class="ci-size">' + escapeHtml(i.variant_title) + '</p>' : '';
      return '<div class="cart-item">' +
        (img ? '<img src="' + img + '" alt="" width="76" height="98">' : '<span></span>') +
        '<div><p class="ci-name">' + escapeHtml(i.product_title) + '</p>' + sizeLine +
        '<span class="qty"><button aria-label="Decrease quantity" data-dec="' + i.key + '">−</button><span>' + i.quantity + '</span><button aria-label="Increase quantity" data-inc="' + i.key + '">+</button></span></div>' +
        '<div class="ci-right"><p class="ci-price">' + money(i.final_line_price / 100) + '</p>' +
        '<button class="ci-remove" data-rm="' + i.key + '">Remove</button></div></div>';
    }).join('');
  }
  function escapeHtml(s){ var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function renderCart(){ fetchCart(); }
  function changeQty(key, qty){
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(function(r){ return r.json(); }).then(function(c){ cartState = c; paintCart(); });
  }
  var cartItemsBox = $('hdCartItems');
  if (cartItemsBox) {
    cartItemsBox.addEventListener('click', function(e){
      var t = e.target;
      if (!cartState) return;
      function lineFor(key){ return cartState.items.find(function(i){ return i.key === key; }); }
      if (t.dataset.inc !== undefined && t.dataset.inc) { var li = lineFor(t.dataset.inc); if (li) changeQty(li.key, li.quantity + 1); }
      else if (t.dataset.dec !== undefined && t.dataset.dec) { var ld = lineFor(t.dataset.dec); if (ld) changeQty(ld.key, ld.quantity - 1); }
      else if (t.dataset.rm !== undefined && t.dataset.rm) { changeQty(t.dataset.rm, 0); }
    });
  }
  function addVariants(ids, openAfter){
    var items = ids.map(function(id){ return {id: parseInt(id, 10), quantity: 1}; });
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items: items})
    }).then(function(r){
      if (!r.ok) return r.json().then(function(err){ throw err; });
      return r.json();
    }).then(function(){
      return fetchCart();
    }).then(function(){
      if (openAfter) openDrawer(cartDrawer, cartBtn);
    }).catch(function(err){
      toast((err && err.description) ? err.description : 'Sorry, that item could not be added.');
    });
  }
  var checkoutBtn = $('hdCheckoutBtn');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function(){ window.location.href = '/checkout'; });

  /* ---- Toast ---- */
  var toastEl = $('hdToast'), toastTimer;
  function toast(msg){
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('on'); }, 2600);
  }

  /* ---- Quick add with size selection ---- */
  document.querySelectorAll('.hd .quick-add').forEach(function(btn){
    var sheet = btn.parentElement.querySelector('.size-sheet');
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      if (btn.dataset.variantId) {
        addVariants([btn.dataset.variantId], false).then(function(){ toast(btn.dataset.name + ' added to your bag'); });
        return;
      }
      document.querySelectorAll('.hd .size-sheet.on').forEach(function(s){ if (s !== sheet) s.classList.remove('on'); });
      if (sheet) sheet.classList.toggle('on');
    });
  });
  document.querySelectorAll('.hd .size-opts button[data-variant-id]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.stopPropagation();
      var sheet = b.closest('.size-sheet');
      var card = b.closest('.card');
      var name = card ? (card.querySelector('.card-name a') || {}).textContent : '';
      addVariants([b.dataset.variantId], false).then(function(){
        toast((name || 'Item') + ' · Size ' + b.textContent.trim() + ' added to your bag');
      });
      if (sheet) sheet.classList.remove('on');
    });
  });
  document.addEventListener('click', function(e){
    if (!e.target.closest('.card-media')) document.querySelectorAll('.hd .size-sheet.on').forEach(function(s){ s.classList.remove('on'); });
  });

  /* ---- Add the look (two items) ---- */
  document.querySelectorAll('.hd .add-look').forEach(function(btn){
    btn.addEventListener('click', function(){
      var ids = (btn.dataset.variants || '').split(',').filter(Boolean);
      if (ids.length) addVariants(ids, true);
    });
  });

  /* ---- Colour swatches (swap image, title, link) ---- */
  document.querySelectorAll('.hd .swatches').forEach(function(group){
    group.querySelectorAll('.swatch').forEach(function(sw){
      sw.addEventListener('click', function(){
        group.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('on'); });
        sw.classList.add('on');
        var card = group.closest('.card');
        if (!card) return;
        var img = card.querySelector('.swatch-img');
        var link = card.querySelector('.swatch-link');
        var title = card.querySelector('.swatch-title');
        if (img && sw.dataset.img) { img.src = sw.dataset.img; img.alt = sw.dataset.title || ''; }
        if (link && sw.dataset.url) link.href = sw.dataset.url;
        if (title && sw.dataset.url) { title.href = sw.dataset.url; if (sw.dataset.title) title.textContent = sw.dataset.title; }
      });
    });
  });

  /* ---- Product rails (scrollable) ---- */
  document.querySelectorAll('.hd [data-rail-wrap]').forEach(function(wrap){
    var rail = wrap.querySelector('.rail');
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    if (!rail) return;
    function railStep(){ var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; }
    if (prev) prev.addEventListener('click', function(){ rail.scrollBy({left: -railStep()*2, behavior: reduceMotion ? 'auto' : 'smooth'}); });
    if (next) next.addEventListener('click', function(){ rail.scrollBy({left: railStep()*2, behavior: reduceMotion ? 'auto' : 'smooth'}); });
  });

  /* ---- Reveal on scroll ---- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold: .1, rootMargin: '0px 0px -5% 0px'});
    document.querySelectorAll('.hd .reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.hd .reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* ---- Initial cart state ---- */
  fetchCart();
})();
